import Model from "@/lib/model/model";

export enum EnumAuditStatus {
  EnumAuditStatusNoAudit = 0, // 待评估
  EnumAuditStatusPass, // 通过
  EnumAuditStatusWait, // 待定
  EnumAuditStatusRefuse // 拒绝
}

export enum EnumAiRecommendStatus {
  EnumAiRecommendStatusDefault = 0, // 默认
  EnumAiRecommendStatusNotRecommend = 10, // 不推荐
  EnumAiRecommendStatusNormal = 20, // 一般
  EnumAiRecommendStatusRecommend = 30, // 推荐
  EnumAiRecommendStatusVeryRecommend = 40 // 非常推荐
}

export class RuleNode extends Model {
  ruleId = 0;
  mergeType: "AND" | "OR" = "AND";
  detail = new ApplicationRule();
  subList: RuleNode[] = [];

  public objectArrayClasses() {
    return {
      subList: RuleNode
    };
  }
}

export class ApplicationRule extends Model {
  applicationRuleId = 0;
  type = "";
  sort = 0;
  auditStatus: EnumAuditStatus = 0;
  auditDesc = "";
  aiRecommendStatus: EnumAiRecommendStatus = 0;
  tagName = ""; // 打标签
  messageType = 0;
  message = "";
  dimensionKey = "";
  dimensionGroupName = "";
  dimensionLevel = 0;
  dimensionLevelDesc = "";
  matchRuleRoot = new RuleNode();
}

export interface MatchNode {
  mergeType?: "AND" | "OR";
  subList?: MatchNode[];
  detail?: {
    attrKey?: string;
    relKey?: string;
    questionId?: number;
    paramsName?: string;
    dimensionKey?: string;
    dimesionGroupName?: string;
    number?: number;
    string?: string;
    strings?: string[];
    enum?: number;
    enums?: number[];
    level?: number;
    levels?: number[];
  };
}

export class Attr extends Model {
  name = "";
  remark = "";
  matchNode: MatchNode = {
    subList: [],
    mergeType: "OR"
  };
}

export class AutoAudit extends Model {
  auditStatus: EnumAuditStatus = 0;
  matchRuleList: Attr[] = [new Attr()];
  constructor(status?: number) {
    super();
    if (status) {
      this.auditStatus = status;
    }
  }
}

export class ExecRule extends Model {
  type = "";
  tagName = "";
  messageType = "";
  message = "";
}
interface MatchRule {
  name: string;
  remark: string;
  matchNode: MatchNode;
}

export class CustomRule extends Model {
  matchRule: MatchRule = {
    name: "",
    remark: "",
    matchNode: {
      mergeType: "OR",
      subList: [{ detail: {} }]
    }
  };
  execRuleList: ExecRule[] = [new ExecRule()];
}

export class ApplicationRuleNew extends Model {
  autoAuditList: AutoAudit[] = [new AutoAudit()];
  customList: CustomRule[] = [new CustomRule()];
}
